import axios from '@axios'

export const state = {
  templates: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allTemplates: (state) => state.templates,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalTemplate: (state) => state.totalTemplate,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_TEMPLATES: (state, data) => {
    if (!data) return false
    state.templates = Array.isArray(data.templates) ? data.templates : []
    state.currentPage =
      typeof data.page === 'number' ? data.page : state.currentPage
    state.perPage =
      typeof data.perPage === 'number' ? data.perPage : state.perPage
    state.totalPages =
      typeof data.totalPages === 'number' ? data.totalPages : state.totalPages
    state.totalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.totalRecords
  },
  CREATE_TEMPLATE: (state, template) => {
    state.templates.unshift(template)
  },
  UPDATE_TEMPLATE: (state, template) => {
    state.templates = state.templates.filter((temp) => temp.id !== template.id)
    state.templates.unshift(template)
  },
  REMOVE_TEMPLATE: (state, template) => {
    state.templates = state.templates.filter((t) => t.id !== template.id)
  },
}

export const actions = {
  async getTemplates({ commit }, params = {}) {
    let { _commit } = params
    if (typeof (_commit) === 'boolean' && _commit === false) return axios.get('/sms/templates', { params: params })
    await axios.get('/sms/templates', { params: params }).then(resp => {
      if (resp.status === 200) {
        commit("GET_TEMPLATES", resp.data)
      }
    })
  },
  async getTemplate({ commit }, template) {
    return axios.get(`/sms/template/${template.id}`, template)
  },
  async createTemplate({ commit }, template) {
    await axios
      .post('/sms/template', template)
      .then((resp) => {
        if (resp.status === 201) {
          commit('CREATE_TEMPLATE', resp.data)
        }
      })
  },
  async updateTemplate({ commit }, template) {
    await axios
      .put(`/sms/template/${template.id}`, template)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_TEMPLATE', resp.data)
        }
      })
  },
  async removeTemplate({ commit }, template) {
    await axios
      .delete(`/sms/template/${template.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_TEMPLATE', template)
        }
      })
  },
}
